import app from 'firebase/app/';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';
//import 'firebase/messaging';


//import {development} from '@barokah-group/development'
import development from '@barokah-group/development'

//import 'firebase/remoteconfig';


const prodConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  //appId: process.env.REACT_FIREBASE_CONFIG_WEB_APP_ID,
};


const developmentMode=false
const config = prodConfig.apiKey === undefined || developmentMode ? development : prodConfig;


class Firebase {
  constructor() {
    app.initializeApp(config);
    //console.log("initializeApp",app)
    this.auth = app.auth();
    this.db = app.database();
    this.fs = app.firestore();
    this.fn = app.functions();
    this.functions=this.fn
    //this.fn.useFunctionsEmulator('http://localhost:3001');
    this.st = app.storage();
    this.storage=this.st
    //this.ms = app.messaging()

    this.GoogleAuthProvider = new app.auth.GoogleAuthProvider()
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignInWithPhone = (phone, password) =>
    this.auth.signInWithPhoneNumber(phone,null);

  doSetPersistence =(persistenceMode)=>
    this.auth.setPersistence(persistenceMode==="local"||persistenceMode==="session"||persistenceMode==="none"?persistenceMode:"local")

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

}

export default Firebase;